module.exports = __webpack_public_path__ + "img/wa-backdrop3.5ab23530.jpg";